module.exports = __webpack_public_path__ + "static/media/indorse-logo@3x.17af7937.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/brand/indorse-logo@3x.png
// module id = 560
// module chunks = 157